import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { useState } from "react";

import { CircularProgress } from "@mui/material";
import { useAuth } from "context/AuthContext";

function SecurityInfoCard({ title, description, action }) {
  const { loading, updatePassword, token } = useAuth();
  const [enable2FA, setEnable2FA] = useState(false);
  const [savingPassword, setSavingPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [newPin, setNewPin] = useState("");
  const [confirmNewPin, setConfirmNewPin] = useState("");
  const [oldPin, setOldPin] = useState("");
  const [newPinSet, setNewPinSet] = useState("");
  const [confirmNewPinSet, setConfirmNewPinSet] = useState("");
  const [newPinLoading, setNewPinLoading] = useState(false);
  const [changePinLoading, setChangePinLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check authentication
    // const token = localStorage.getItem('token');
    // const userId = localStorage.getItem('userId');

    if (!token) {
      setSnackbar({
        open: true,
        message: "Please log in to change your password",
        severity: "error",
      });
      return;
    }

    if (!oldPassword || !newPassword || !confirmNewPassword) {
      setSnackbar({
        open: true,
        message: "Please fill in all password fields",
        severity: "error",
      });
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setSnackbar({
        open: true,
        message: "New password and confirm password must match",
        severity: "error",
      });
      return;
    }

    try {
      setSavingPassword(true);

      const passwordData = {
        // id: parseInt(userId),
        currentPassword: oldPassword,
        newPassword,
        confirmNewPassword,
      };

      const response = await updatePassword(passwordData);

      // AuthContext.updatePassword now returns response.data on success
      if (response) {
        // setSnackbar({ open: true, message: 'Password changed successfully!', severity: 'success' });
        setOldPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
      } else {
        const errorMessage = response?.message || "Failed to change password";
        // setSnackbar({ open: true, message: errorMessage, severity: 'error' });
        console.log(errorMessage);
      }
    } catch (error) {
      console.error("Error changing password:", error);
      setSnackbar({
        open: true,
        message: "An error occurred while changing password",
        severity: "error",
      });
    } finally {
      setSavingPassword(false);
    }
  };

  const handleToggle2FA = () => {
    setEnable2FA(!enable2FA);
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // const handleSetTransactionPin = async () => {
  //   const token = localStorage.getItem('token');
  //   if (!token) {
  //     alert('Token not found in local storage.');
  //     return;
  //   }

  //   if (newPin !== confirmNewPin) {
  //     alert("New PIN and Confirm New PIN must match.");
  //     return;
  //   }

  //   try {
  //     setNewPinLoading(true)
  //     const response = await setTransactionPin(token, newPin, confirmNewPin);
  //     // Handle the response here
  //     console.log('Transaction PIN set successfully:', response.data);
  //     setNewPinLoading(false)
  //   } catch (error) {
  //     // Handle errors here
  //     console.error('Error setting transaction PIN:', error);
  //   }
  // };

  // const setTransactionPin = async (token, pin, pinConfirm) => {
  //   const apiUrl = '/api/merchant/set-pin'; // Replace with your API endpoint
  //   const requestData = {
  //     confirmPin: pinConfirm,
  //     pin: pin,
  //   };

  //   const headers = {
  //     'Authorization': `Bearer ${token}`,
  //   };

  //   try {

  //     const response = await axios.post(apiUrl, requestData, { headers });
  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  // const handleChangeTransactionPin = async () => {
  //   const token = localStorage.getItem('token');
  //   if (!token) {
  //     alert('Token not found in local storage.');
  //     return;
  //   }

  //   if (newPinSet !== confirmNewPinSet) {
  //     alert("New PIN and Confirm New PIN must match.");
  //     return;
  //   }

  //   try {
  //     setChangePinLoading(true)
  //     const response = await changeTransactionPin(token, newPinSet, confirmNewPinSet, oldPin);
  //     // Handle the response here
  //     console.log('Transaction PIN changed successfully:', response.data);
  //     setChangePinLoading(false)
  //   } catch (error) {
  //     // Handle errors here
  //     console.error('Error changing transaction PIN:', error);
  //   }
  // };

  // const changeTransactionPin = async (token, pinSet, pinSetConfirm, pinOld) => {
  //   const apiUrl = '/api/merchant/change-pin'; // Replace with your API endpoint
  //   const requestData = {
  //     currentPin: pinOld,
  //     newPin: pinSet,
  //     confirmNewPin: pinSetConfirm
  //   };

  //   const headers = {
  //     'Authorization': `Bearer ${token}`,
  //   };

  //   try {
  //     const response = await axios.post(apiUrl, requestData, { headers });
  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <SoftBox
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          pb={2}
        >
          <SoftTypography
            variant='h6'
            fontWeight='medium'
            textTransform='capitalize'
          >
            {title}
          </SoftTypography>
        </SoftBox>
        <Divider />
        <Grid container spacing={2}>
          {/* Enable/Disable 2FA */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch checked={enable2FA} onChange={handleToggle2FA} />
              }
              label='Enable/Disable 2FA'
            />
            <Divider variant='middle' />
          </Grid>
          {/* Change Password */}
          <Grid item xs={12}>
            <Divider variant='middle' />
            <Grid item xs={12} sm={6} md={5} lg={6} xl={6}>
              <h3 style={{ fontSize: "16px", fontWeight: "bold" }}>
                Change Password
              </h3>
              <Divider variant='middle' />
              <TextField
                id='old-password'
                type='password'
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                variant='outlined'
                margin='normal'
                fullWidth
                placeholder='* Old Password'
              />
            </Grid>
            <Divider variant='middle' />
            <Grid item xs={12} sm={6} md={5} lg={6} xl={6}>
              <TextField
                id='new-password'
                type='password'
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                variant='outlined'
                margin='normal'
                fullWidth
                placeholder='* New Password'
              />
            </Grid>
            <Divider variant='middle' />
            <Grid item xs={12} sm={6} md={5} lg={6} xl={6}>
              <TextField
                id='confirm-new-password'
                type='password'
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                variant='outlined'
                margin='normal'
                fullWidth
                placeholder='* Confirm New Password'
              />
            </Grid>
            <Button
              style={{ color: "white" }}
              type='submit'
              variant='contained'
              color='primary'
              onClick={handleSubmit}
            >
              {savingPassword ? (
                <CircularProgress size={24} color='inherit' />
              ) : (
                "Save"
              )}
            </Button>
            <Divider variant='middle' />
          </Grid>
          {/* Set Transaction PIN */}
          {/* <Grid item xs={12}>
            <Divider variant="middle" />
            <Grid item xs={12} sm={6} md={5} lg={6} xl={6}>
              <h3 style={{ fontSize: "16px", fontWeight: "bold" }}>Set Transaction PIN</h3>
              <Divider variant="middle" />
              <TextField
                id="new-set-pin"
                type="password"
                value={newPin}
                onChange={(e) => setNewPin(e.target.value)}
                variant="outlined"
                margin="normal"
                fullWidth
                placeholder="* New Pin"
              />
            </Grid>
            <Divider variant="middle" />
            <Grid item xs={12} sm={6} md={5} lg={6} xl={6}>
              <TextField
                id="confirm-new-set-pin"
                type="password"
                value={confirmNewPin}
                onChange={(e) => setConfirmNewPin(e.target.value)}
                variant="outlined"
                margin="normal"
                fullWidth
                placeholder="* Confirm New Pin"
              />
            </Grid>
            <Button disabled={newPinLoading} style={{ color: "white" }} type="submit" variant="contained" color="primary" onClick={handleSetTransactionPin}>
              {newPinLoading ? 'Loading...' : 'Save'}
            </Button>
            <Divider variant="middle" />
          </Grid> */}
          {/* Change Transaction PIN */}
          {/* <Grid item xs={12}>
            <Divider variant="middle" />
            <Grid item xs={12} sm={6} md={5} lg={6} xl={6}>
              <h3 style={{ fontSize: "16px", fontWeight: "bold" }}>Change Transaction PIN</h3>
              <Divider variant="middle" />
              <TextField
                id="old-pin"
                type="password"
                value={oldPin}
                onChange={(e) => setOldPin(e.target.value)}
                variant="outlined"
                margin="normal"
                fullWidth
                placeholder="* Old Pin"
              />
            </Grid>
            <Divider variant="middle" />
            <Grid item xs={12} sm={6} md={5} lg={6} xl={6}>
              <TextField
                id="confirm-new-pin"
                type="password"
                value={newPinSet}
                onChange={(e) => setNewPinSet(e.target.value)}
                variant="outlined"
                margin="normal"
                fullWidth
                placeholder="* New Pin"
              />
            </Grid>
            <Divider variant="middle" />
            <Grid item xs={12} sm={6} md={5} lg={6} xl={6}>
              <TextField
                id="confirm-new-change-pin"
                type="password"
                value={confirmNewPinSet}
                onChange={(e) => setConfirmNewPinSet(e.target.value)}
                variant="outlined"
                margin="normal"
                fullWidth
                placeholder="* Confirm New Pin"

              />
            </Grid>
            <Button disabled={changePinLoading} style={{ color: "white" }} type="submit" variant="contained" color="primary" onClick={handleChangeTransactionPin}>
              {changePinLoading ? 'Loading...' : 'Save'}
            </Button>
          </Grid> */}
        </Grid>
      </CardContent>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
}

// Typechecking props for the ProfileInfoCard
SecurityInfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  // action: PropTypes.shape({
  //   route: PropTypes.string.isRequired,
  //   tooltip: PropTypes.string.isRequired,
  // }).isRequired,
};

export default SecurityInfoCard;
